import React, { useEffect, useState } from 'react';
import { setGlobalErrorHandler } from '@/web-client';
import { useModalDialog } from '@/hooks/useModalDialog';

const WebApiErrorHandler: React.FC = ({ children }) => {

    const { open } = useModalDialog()

    useEffect(() => {
        setGlobalErrorHandler(async e => {
            await open({
                title: "システムエラーが発生しました。",
                message: e.response?.data?.message,
            });
 
        })
    }, [])

    return <>{children}</>
}

export default WebApiErrorHandler;